import { useEffect } from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 UBICACIÓN EN EL MAPA — react-leaflet

    ⚠️ EL ÍCONO ROTO DE LEAFLET

    Leaflet busca sus imágenes por ruta relativa, y con webpack esas
    rutas no existen: el marcador sale como imagen quebrada. Hay que
    importarlas y reconstruir el ícono a mano. Es el bug más conocido
    de leaflet con bundlers.

    El CSS de leaflet se importa una vez en App.js.
*/

L.Icon.Default.mergeOptions({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
});

const DEFAULT_CENTER = [-38.4161, -63.6167];   // Argentina

const ClickCatcher = ({ onPick, isDisabled }) => {

    useMapEvents({
        click: (event) => {
            if (isDisabled) return;
            onPick?.({ lat: event.latlng.lat, lng: event.latlng.lng });
        },
    });

    return null;
};

export const FieldMap = ({
    id, label, hint, error,
    value = null,                 // { lat, lng } | null
    onChange, center = null, zoom = 13, height = 280,
    isDisabled = false, span = 2,
}) => {

    const POSITION = value ? [value.lat, value.lng] : null;

    const CENTER = center ?? POSITION ?? DEFAULT_CENTER;

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled}
            hint={hint ?? (value
                ? `${value.lat.toFixed(5)}, ${value.lng.toFixed(5)}`
                : 'Hacé clic en el mapa para marcar la ubicación')} >

            <div className={`${BLOCK}__map`} style={{ height }} data-disabled={isDisabled}>

                <MapContainer center={CENTER} zoom={zoom} scrollWheelZoom={false}
                    style={{ height: '100%', width: '100%' }} >

                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    <ClickCatcher onPick={onChange} isDisabled={isDisabled} />

                    {POSITION && <Marker position={POSITION} />}

                </MapContainer>

            </div>

            {
                value && !isDisabled && (
                    <button type="button" className={`${BLOCK}__map_clear`}
                        onClick={() => onChange?.(null)} >
                        Quitar ubicación
                    </button>
                )
            }

        </FieldShell>
    );
};
